var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVulnKb = function SvgVulnKb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "kb",
    width: 12.41,
    height: 19,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58 12.667V9.896l.479-.36a4.418 4.418 0 0 0-2.651-7.953h-.406A4.418 4.418 0 0 0 1.81 4.605 4.41 4.41 0 0 0 3.353 9.53l.477.357v2.779h4.75Zm1.583 0c0 .874-.709 1.583-1.583 1.583H3.83a1.583 1.583 0 0 1-1.584-1.583v-1.99A5.993 5.993 0 0 1 .308 4.104 6.002 6.002 0 0 1 6.002 0h.406a6.002 6.002 0 0 1 3.755 10.684v1.983ZM3.83 16.625a.792.792 0 1 1 0-1.583h4.75a.792.792 0 1 1 0 1.583H3.83ZM4.62 19a.792.792 0 1 1 0-1.583h3.167a.792.792 0 1 1 0 1.583H4.621Z",
    fill: "#264D6D",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVulnKb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vuln-kb.6ac0b0d7.svg";
export { ForwardRef as ReactComponent };